interface NodeLike {
  id: number;
  childNodes?: Record<string, NodeLike | NodeLike[] | undefined>;
}

export const subtreeContainsId = (node: NodeLike, targetId: number): boolean => {
  if (node.id === targetId) return true;
  if (!node.childNodes) return false;
  return Object.values(node.childNodes).some((child) => {
    if (Array.isArray(child)) return child.some((c) => subtreeContainsId(c, targetId));
    return child ? subtreeContainsId(child, targetId) : false;
  });
};
